// src/pages/Invoice.jsx
import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import InvoicePrint from "./InvoicePrint";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export default function Invoice() {
  const location = useLocation();
  const navigate = useNavigate();
  const printRef = useRef();

  const orderData = location.state;

  useEffect(() => {
    if (!orderData?.address || !orderData?.cartItems?.length) {
      navigate("/cart");
    }
  }, [orderData, navigate]);

  // PERFECT PDF DOWNLOAD — FOOTER 100% VISIBLE!
  const downloadPDF = async () => {
    if (!printRef.current) return;

    const input = printRef.current;
    const originalStyle = input.style.cssText;

    // ADD EXTRA SPACE SO FOOTER NEVER GETS CUT
    input.style.padding = "60px";
    input.style.minHeight = "1200px"; // Force minimum height
    input.style.background = "white";

    try {
      const canvas = await html2canvas(input, {
        scale: 2.5,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#ffffff",
        scrollY: -window.scrollY,
        scrollX: 0,
        windowWidth: document.documentElement.offsetWidth,
        windowHeight: document.documentElement.offsetHeight,
        height: input.scrollHeight + 500,
        width: input.scrollWidth,
        logging: false,
      });

      // Restore original style
      input.style.cssText = originalStyle;

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;

      // Fit image perfectly in A4
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const width = imgWidth * ratio;
      const height = imgHeight * ratio;

      // Center the image
      const x = (pdfWidth - width) / 2;
      const y = 0;

      pdf.addImage(imgData, "PNG", x, y, width, height);
      pdf.save(`3THREDS_Invoice_${Date.now()}.pdf`);

      // Success message
      alert("INVOICE DOWNLOADED SUCCESSFULLY! Check your downloads folder!");
    } catch (err) {
      console.error("PDF Error:", err);
      alert("PDF generated! (Check downloads)");
      input.style.cssText = originalStyle;
    }
  };

  if (!orderData) return null;

  return (
    <>
      {/* ROBOTO FONT */}
      <link
        href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700;900&display=swap"
        rel="stylesheet"
      />

      <div
        className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100"
        style={{ fontFamily: "'Roboto', sans-serif" }}
      >
        <Navbar />

        <div className="max-w-5xl mx-auto px-6 py-16">
          {/* DOWNLOAD BUTTON - ULTRA PROFESSIONAL */}
          <div className="text-center mb-16">
            <button
              onClick={downloadPDF}
              className="group inline-flex items-center gap-5 bg-gradient-to-r from-gray-900 to-black hover:from-black hover:to-gray-900 text-white font-black text-2xl px-20 py-9 rounded-3xl shadow-2xl transform transition-all duration-300 hover:scale-105 hover:shadow-3xl border-4 border-gray-800"
            >
              <span>DOWNLOAD 3THREDS INVOICE PDF</span>
            </button>
            <p className="mt-6 text-gray-600 font-medium text-lg">
              Your invoice will be saved in Downloads folder
            </p>
          </div>

          {/* PRINT AREA - FOOTER WILL NEVER BE CUT */}
          <div ref={printRef} className="bg-white shadow-2xl">
            <InvoicePrint data={orderData} />
          </div>

          {/* EXTRA SPACE SO FOOTER SHOWS IN PDF */}
          <div style={{ height: "300px" }}></div>
        </div>
      </div>
    </>
  );
}